export default class ProjectNamespaceTreeRequest  {
	ProjectId!: number;
	OnlyConfigured: boolean = false;
	constructor(obj?: Partial<ProjectNamespaceTreeRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
